import { CardHeader, Grid } from '@mui/material';
import { styled } from '@mui/system';

export const GridWrapper = styled(Grid)(({ theme }) => ({
  background: '#fff',
  borderRadius: 20,
  padding: '1em'
}));

export const GridDisabledWrapper = styled(Grid)(({ theme }) => ({
  background: '#fff',
  borderRadius: 20
}));

export const CardNoFlex = styled(CardHeader)(({ theme }) => ({
  display: 'block',

  [theme.breakpoints.down('lg')]: {
    minHeight: '100px'
  }
}));

export const GridAlignEnd = styled(Grid)(({ theme }) => ({
  alignItems: 'flex-end',
  justifyContent: 'center'
}));
